export default __webpack_public_path__ + "static/media/Boots of Quilled Darts.db8e2d05.jpg";